import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAtom } from 'jotai';
// state
import { userRecordAtom } from '../../shared/state/atoms';
// paths
import { PATH_PROVIDER } from '../../shared/routes/paths';

export default function BankingDetailsGuard({ children }) {
  const [user] = useAtom(userRecordAtom);
  const hasBankingDetails = user?.paymentDetails?.paystackSubaccountCode;

  if (!hasBankingDetails) {
    return <Navigate to={PATH_PROVIDER.bankingDetails} replace />;
  }

  return <>{children}</>;
}

BankingDetailsGuard.propTypes = {
  children: PropTypes.node,
};
